// Recursively search the node by name in the hierarchy: O(|nodes|)

export function findNodeByRoomName(name, hierarchy) {
  // If current node matches the name, return it
  if (hierarchy[name]) {
    return hierarchy[name];
  }

  const nodeChildren = Object.values(hierarchy)[0].children;
  // Else search the node children
  if (nodeChildren) {
    let foundNode = null;
    // Stop iterating over the children as soon as the node is found
    Object.entries(nodeChildren).some(([nodeName, nodeObject]) => {
      const nodeHierarchy = { [nodeName]: nodeObject };
      foundNode = findNodeByRoomName(name, nodeHierarchy);
      return foundNode !== null;
    });
    return foundNode;
  }

  return null;
}
